import { useState } from "react"
import { getProgramCacheMeta, MessageProgramsUpdated } from "./program-cache"

/**
 * Subscribe to module-level message program cache loading state.
 * @returns {{ status: string, language: string, namespacesKey: string, generation: number }}
 */
export function useMessageProgramsStatus() {
    const [meta, setMeta] = useState(getProgramCacheMeta)

    MessageProgramsUpdated.useEvent(syncMeta, [])

    return {
        status: meta.status,
        language: meta.language,
        namespacesKey: meta.namespacesKey,
        generation: meta.generation,
    }

    function syncMeta() {
        setMeta(getProgramCacheMeta())
    }
}
